export const ifWindowWidthLessThan = (width) => {
    return window.innerWidth <= width;
};

export const getChartsRatio = () => {
    return ifWindowWidthLessThan(768) ? 1.1 : ifWindowWidthLessThan(1200) ? 1.5 : 2.0;
};
